import { type ReactElement } from 'react'
import { Box, Tooltip } from '@mui/material'
import { formatKn } from '../utils'
import LoadCaseCombinationFormula from './LoadCaseCombinationFormula'

interface Props {
  force?: DesignSupportForce
}

/** Design force of one combination set, naming its load case combination in a tooltip. */
export const DesignSupportForceCell = ({ force }: Props): ReactElement => {
  if (!force) return <Box>-</Box>

  return (
    <Tooltip
      title={force.lcc?.data?.length ? <LoadCaseCombinationFormula lcc={force.lcc} /> : ''}
      arrow
      placement="top"
      disableInteractive
    >
      <Box sx={{ width: 'fit-content' }}>{formatKn(force.design_force)}</Box>
    </Tooltip>
  )
}
